import React from "react";

export const CheckIcon = ({ width, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width }}
    className={className}
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
